export const isRejected = input => input.status === 'rejected';
export const isFulfilled = input => input.status === 'fulfilled';
export function getFulfilled(result) {
  return result.filter(isFulfilled).map(r => r.value);
}
export function getRejected(result) {
  return result.filter(isRejected).map(r => r.reason);
}